import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AppFlashMessage = (props) => {
  const message = props.message || {};
  const classes = classnames(
    'appFlashMessage',
    {
      'appFlashMessage--visibile' : message.title && message.text,
      'appFlashMessage--warning': message.type === 'warning',
      'appFlashMessage--error': message.type === 'error',
    });
  return (
    <section className={classes} onClick={props.onDismiss}>
      <div className="appFlashMessage__icon">
        <i className="bi_web-warning" />
      </div>
      <div className="appFlashMessage__content">
        <h6>{message.title}</h6>
        <p>{message.text}</p>
      </div>
    </section>
  );
};

AppFlashMessage.propTypes = {
  message: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.oneOf(['warning', 'error']),
  }),
  onDismiss: PropTypes.func,
};

export default AppFlashMessage;



// WEBPACK FOOTER //
// ./src/components/app-flash-message.js